/** The `?redirect=` target on /login, or null unless it is a path on this origin. */
export function loginRedirectPath(search: string): string | null {
  const target = new URLSearchParams(search).get("redirect");
  if (!target || !target.startsWith("/") || target.startsWith("//") || target.startsWith("/\\")) {
    return null;
  }
  return target;
}
